import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { OverflowTextPipe } from '@app/pipe/overflow-text.pipe';

@Component({
  selector: 'app-overflow-num-tooltip',
  templateUrl: './overflow-num-tooltip.component.html',
  styleUrl: './overflow-num-tooltip.component.less',
  providers: [OverflowTextPipe]
})
export class OverflowNumTooltipComponent implements OnInit {
  @Input() text  = '';
  @Input() maxLength = 20;
  @Input() isEnabled: boolean = true;
  showText = '';

  constructor(private overflowTextPipe: OverflowTextPipe) {
  }

  isMemberEnabled(): boolean {
    return this.isEnabled ?? true;
  }

  ngOnInit(): void {
    this.showText = (this.maxLength && this.text?.length > this.maxLength) ?
        this.overflowTextPipe.transform(this.text,this.maxLength) : this.text;
  }
}
